import { useMemo } from "react";
import { hotelOptionScenarios, priceItemSet } from "@/lib/quoteChoices";

interface Props {
  items: any[];
  currency: string;
  priceOpts: Parameters<typeof priceItemSet>[1];
}

const fmt = (n: number) => Math.round(n).toLocaleString();

/** Internal margin preview per hotel option — never shown on the quote. */
export function HotelOptionMarginsCard({ items, currency, priceOpts }: Props) {
  const groups = useMemo(() => hotelOptionScenarios(items as any[]), [items]);
  if (!groups.length) return null;
  return (
    <div className="rounded-lg border border-border bg-muted/30 p-3 space-y-2">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-sm font-semibold">Margin by alternative option</span>
        <span className="text-[10px] text-muted-foreground">Internal — never on the quote</span>
      </div>
      {groups.map((g, gi) => (
        <div key={gi} className="space-y-1">
          {groups.length > 1 && <div className="text-xs text-muted-foreground">Swapping: {g.groupLabel}</div>}
          <table className="w-full text-xs">
            <thead>
              <tr className="text-muted-foreground">
                <th className="text-left font-normal">Option</th>
                <th className="text-right font-normal">Cost</th>
                <th className="text-right font-normal">Selling</th>
                <th className="text-right font-normal">Margin</th>
                <th className="text-right font-normal">%</th>
              </tr>
            </thead>
            <tbody>
              {g.options.map((o, oi) => {
                const p = priceItemSet(o.items, priceOpts);
                return (
                  <tr key={oi} className="border-t border-border/50">
                    <td className="py-1 pr-2">{o.label}{o.isBase && <span className="text-muted-foreground"> (base)</span>}</td>
                    <td className="text-right">{fmt(p.cost)}</td>
                    <td className="text-right">{fmt(p.selling)}</td>
                    <td className={`text-right font-medium ${p.margin < 0 ? "text-destructive" : ""}`}>{fmt(p.margin)}</td>
                    <td className="text-right">{p.marginPct.toFixed(1)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
      <p className="text-[10px] text-muted-foreground">Amounts in {currency}. Whole programme per option; optional extras excluded.</p>
    </div>
  );
}
